import { getEnumValues } from './get-enum-values';
export enum AthleteProfileStatus{
	/** This profile was automatically generated and is not owned by any user yet */
	Placeholder="Placeholder",
	/** This profile was automatically but has been claimed by a user */
	PlaceholderClaimed="PlaceholderClaimed",
}
export const AthleteProfileStatusValues = getEnumValues<AthleteProfileStatus>(AthleteProfileStatus)